export default "__VITE_ASSET__DxNzEy8b__"